import { BoxLabelIncident } from "@deliverr/commons-clients";

export const findMatchingIncidentItem = (barcodeToMatch: string, incident?: BoxLabelIncident) => {
  return incident?.dskus?.find(({ barcode }) => barcode === barcodeToMatch);
};
